import ApiService from '.';
import { CreateBookingParams } from '../params/redux/booking';
/**
 * @heading1: Integration API service.
 * @paragraph: This module provides a set of methods to interact with the Integration API.
 * It handles operations like Fetching folder details and create folder.
 */
const BookingApi = {
    fetchEventDetail: (token: string, unique_id: string) => {
        // Perform a POST request to fetch folders with the provided data
        return ApiService.apiHit({
            url: 'get-calendar-booking-details',
            method: 'post',
            token,
            data: { unique_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchSlotDetails: (token: string, unique_id: string, date: string, time_zone: string) => {
        // Perform a POST request to fetch folders with the provided data
        return ApiService.apiHit({
            url: 'get-calendar-booking-hours-details',
            method: 'post',
            token,
            data: { unique_id, date, time_zone },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    createBooking: (token: string, data: CreateBookingParams) => {
        // Perform a POST request to fetch folders with the provided data
        return ApiService.apiHit({
            url: 'create-calendar-booking',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    }
};

export default BookingApi;
